import NotFound from '../components/pages/NotFound';

export default [
    {
        path: '*',
        component: NotFound,
        name: '404'
    },
]
